
import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/replenishment/waybill`;
const GATEWAYLOC_URL = `${Config.VITE_APP_GATEWAY_URL}/api/replenishment/location`;
const GATEWAYLVEN_URL = `${Config.VITE_APP_GATEWAY_URL}/api/replenishment/vendor`;

export const waybillService = {

    getWaybillList: async function (WaybillNo: any, OrderIds: any, VendorCode: any, ProductCode: any, StartDate: any, EndDate: any) {
        return axios.get(`${GATEWAY_URL}/waybill_list`, {
            params: {
                WayBillNo: WaybillNo,
                OrderCodes: OrderIds,
                VendorCode: VendorCode,
                ProductCode: ProductCode,
                StartDate: StartDate,
                EndDate: EndDate
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    getVendorLookups: async function () {
        return axios.get(`${GATEWAY_URL}/waybill_vendor_lookup`, {
        })
            .then((response) => {
                return response.data;
            });
    },

    getTermsLookups: async function () { 
        return axios.get(`${GATEWAY_URL}/waybill_terms_lookup`, {
        })
            .then((response) => {
                return response.data;
            });
    },

    getLocationLookups: async function () {
        return axios.get(`${GATEWAYLOC_URL}/location_list`, {
        })
            .then((response) => {
                return response.data;
            });
    },

    getProductLookups: async function () {
        return axios.get(`${GATEWAY_URL}/waybill_product_lookup`, {
        })
            .then((response) => {
                return response.data;
            });
    },

    getWaybill: async function (id: any) {
        return axios.get(`${GATEWAY_URL}/get_waybill`, {
            params: { id }
        })
            .then((response) => {
                return response.data;
            });
    },

    getWaybillDetailList: async function (WayBillId: any) {
        return axios.get(`${GATEWAY_URL}/waybill_detail_list`, {
            params: { WayBillId }
        })
            .then((response) => {
                return response.data;
            });
    },

    updateWaybillMaster: async function (values: any) {
        return axios.put(`${GATEWAY_URL}/update_waybill`, values) 
            .then((response) => {
                return response.data;
            });
    },

    updateWaybillDetail: async function (values: any) {
        return axios.put(`${GATEWAY_URL}/save_waybill_detail`, values)
            .then((response) => {
                return response.data;
            });
    },

    waybill_approve: async function (WaybillId?: number) {
        return axios.get(`${GATEWAY_URL}/waybill_approve`, {
            params: {
                WayBillId: WaybillId
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    waybill_reject: async function (waybillId: number, rejectReason: string) {
        return axios.get(`${GATEWAY_URL}/waybill_reject`, {
            params: {
                WayBillId: waybillId,
                RejectReason: rejectReason
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    getOrderNoLookups: async function (vendorCode: string, locationCode: string) {
        return axios.get(`${GATEWAY_URL}/waybill_orderno_lookup`, {
            params: {
                VendorCode: vendorCode,
                LocationCode: locationCode
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    orderLinesList: async function (orders: string[]) {
        return axios.post(`${GATEWAY_URL}/order_lines_list`,
            { orderLines: orders }
        )
            .then((response) => {
                return response.data;
            });
    },

    saveWaybill: async function (values: any) {
        return axios.put(`${GATEWAY_URL}/save_waybill`, values)
            .then((response) => {
                return response.data;
            });
    },

    getDownloadWaybillPdf: async (WayBillId : number, fileName: string) => {
        try {
            const response = await axios.get(`${GATEWAY_URL}/download/` + WayBillId + `/` + fileName, {
                responseType: "blob",
                headers: {
                    Accept: ".pdf",
                },
            });
            const blob = new Blob([response.data], {
                type: ".pdf",
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Download error :', error);
        }
    }
}

